export var commonFamilyMemDetailsMapper = function (data) {
    var result = {
        status: false,
        message: "",
    };
    if (data) {
        result.message = data === null || data === void 0 ? void 0 : data.data;
        result.status = true;
    }
    return result;
};
export var deleteFamilyMapper = function (params) {
    var _a, _b;
    var result = {
        status: false,
        message: "",
    };
    if (params) {
        result.message = ((_a = params.data) === null || _a === void 0 ? void 0 : _a.message) ? (_b = params.data) === null || _b === void 0 ? void 0 : _b.message : "";
        result.status = params.success;
    }
    return result;
};
export var deleteFamilyMember = function (data) {
    var result = {
        status: false,
        message: "",
    };
    if (data) {
        result.message = data.data;
        result.status = data.success;
    }
    return result;
};
